import React from 'react';
import { FadeIn } from './FadeIn';
export function FamiliarSituations() {
  const situations = ['Se despierta a las 2 o 3 de la madrugada con un dolor que no la deja volver a dormir.', "Sus rodillas o espalda le 'avisan' el clima antes que cualquier pronóstico.", 'Su pastillero semanal está tan lleno que ya no sabe qué pastilla es para qué.', "Compró tés y cremas 'naturales' en la farmacia y no sintió ningún cambio real.", 'Extraña los remedios de su tierra pero aquí no sabe dónde conseguirlos.'];
  return <section className="py-16 px-6 bg-cream-dark/50" data-id="element-48">
      <div className="max-w-3xl mx-auto" data-id="element-49">
        <FadeIn data-id="element-50">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brown-dark mb-12" data-id="element-51">
            ¿Le suena familiar alguna de estas situaciones?
          </h2>

          <div className="space-y-4 mb-12" data-id="element-52">
            {situations.map((situation, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-53">
                <div className="flex items-start p-5 bg-white rounded-2xl shadow-sm border border-cream-dark hover:shadow-md transition-shadow" data-id="element-54">
                  <span className="text-2xl mr-4 shrink-0 mt-0.5" data-id="element-55">😔</span>
                  <p className="text-lg text-brown" data-id="element-56">{situation}</p>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn delay={0.6} data-id="element-57">
            <div className="text-center" data-id="element-58">
              <p className="text-2xl font-serif italic text-sage-dark font-medium" data-id="element-59">
                Si asintió con la cabeza aunque sea una vez... este libro fue
                escrito para usted.
              </p>
            </div>
          </FadeIn>
        </FadeIn>
      </div>
    </section>;
}